import React, {useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {Button, Theme, Box,IconButton} from '@mui/material';
import {SelectSmart} from "./CustomTextField";

const useStyles = makeStyles((theme:Theme) => ({
  root: {
    position: 'fixed',
    width: "100%",
    boxShadow: "none",
  },
  btn: {
    [theme.breakpoints.down('sm')]: {
      minWidth: 39,
    }
  },
  label:{
    position: "relative",
    "& .MuiInputBase-root":{
      position: "absolute",
      left: "0",
      width: "100%",
      marginTop: "0 !important",
      paddingRight: 0,
      opacity: "0"
    }
  }
}));
interface IProps {
  smIcon?: any,
  text?: string,
  opcions?: {key:string, value:string, disabled?:boolean, icon?:any}[]
  disabled?: boolean
  onChange:(val:string)=>void
}
export default function ButtonSelect({smIcon,text,opcions,disabled,onChange}:IProps){
  const classes = useStyles();
  const [value] = useState("");


  const handleChange = (e:React.ChangeEvent<HTMLSelectElement>)=>{
    const {value} = e.target
    onChange(value)
  }

  return (
    <label className={classes.label}>
        {(text && smIcon)?(
            <Button  color="inherit" className={classes.btn} disabled={disabled} >
              <Box component="span" sx={{ display: { xs: 'none', md: 'block' } }} >{text}</Box>
              <Box component="span" sx={{ display: { sm: 'block', md: 'none', } }} >{smIcon}</Box>
            </Button>
            ):(
            <IconButton>{smIcon}</IconButton>
            )
        }



      <SelectSmart
          disabled={disabled}
          value={value}
          onChange={handleChange}
          opciones={opcions}
      />
    </label>
  );
}

